

const link = {
    label: 'Link',
    name: 'link',
    widget: 'object',
    fields: [
        {
            label: 'Label',
            name: 'label',
            widget: 'string',
            required: true,
            i18n : true,
        },
        {
            label: 'Url',
            name: 'url',
            widget: 'string',
            required: true,
            i18n : true,
        },
    ],
}


export default {
    label: 'Blog Settings',
    name: 'docs_settings',
    file: 'src/content/settings/docs_settings.json',
    i18n: true,
    fields: [
        {
            label: 'Title',
            name: 'title',
            widget: 'string',
            i18n: true
        },
        {
            label: 'Navigation',
            name: 'navigation',
            widget: 'list',
            i18n: true,
            types : [link]
        }
    ],
};